<template>
    <div class="title">
        <heading :level="1">{{ $json.title }}</heading>
    </div>
</template>

<script>
import Heading from 'gvue/src/core/Heading'

export default {
    name: 'SectionTitle',
    components: { Heading }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
.title
    position: relative
    z-index: 0

.g_h1
    position: absolute
    top: ($gap * 0.5)
    right: 60%
    transform-origin: top right
    transform: rotate(-90deg)
    font-size: 1.75em
    letter-spacing: 0.5em
    line-height: 1
    font-weight: 700

+desktop
    .title
        background-color: $color_background

    .g_h1
        top: 50%
        right: 50%
        transform-origin: center center
        transform: translateX(50%) translateY(-50%) rotate(-90deg)
</style>
